import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const BlogTree: LoadableType<{
	spaceKey: string;
	pageTreeFinishedLoading: boolean;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-BlogTree" */ '../src/BlogTree.tsx')).BlogTree,
});
